import { getToken } from "@/utils/token";
import route from '@/router'
import { Message } from 'element-ui';
import { login } from "@/api/user";
const state = {
  token: getToken(),
  userinfo: {
    username: "",
    password: "",
  }
};
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  LOGOUT: (state) => {
    state.token = null
    route.push('/login')
  }
};
const actions = {
  Login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo).then(res => {
        if (res.code == 100000) {
          const { data } = res
          commit('SET_TOKEN', data.access_token)
          resolve()
        } else {
          reject(res.message)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  Logout({ commit }) {
    Message.success('退出登录成功！')
    commit("LOGOUT")
  },
  ResetToken({ commit }) {
    Message.error('登录失效，请重新登录！')
    commit("LOGOUT")
  },

};
export default {
  state,
  mutations,
  actions,
}